import { Avatar, AvatarFallback, AvatarImage } from "~/components/ui/avatar";
import { Tooltip, TooltipContent, TooltipTrigger } from "~/components/ui/tooltip";
import { cn } from "~/lib/utils";

export interface AvatarStackItem {
  id: string;
  name: string;
  imageUrl?: string;
}

interface AvatarStackProps {
  items: AvatarStackItem[];
  max?: number;
}

export function AvatarStack({ items, max = 5 }: AvatarStackProps) {
  if (items.length === 0) {
    return <span className="text-sm text-muted-foreground">—</span>;
  }
  const overflow = items.length - max;
  const overflowItems = items.slice(max);
  return (
    <div className="flex items-center gap-1">
      <div className="flex items-center">
        {items.slice(0, max).map((item, i) => (
          <Tooltip key={item.id}>
            <TooltipTrigger asChild>
              <span
                className={cn(
                  "relative inline-flex rounded-full ring-2 ring-card transition-transform duration-75 hover:z-10 hover:scale-110",
                  i > 0 && "-ml-1"
                )}
              >
                <Avatar className="size-6">
                  <AvatarImage src={item.imageUrl} />
                  <AvatarFallback className="text-xs">
                    {item.name.charAt(0).toUpperCase()}
                  </AvatarFallback>
                </Avatar>
              </span>
            </TooltipTrigger>
            <TooltipContent>{item.name}</TooltipContent>
          </Tooltip>
        ))}
      </div>
      {overflow > 0 && (
        <Tooltip>
          <TooltipTrigger asChild>
            <span className="cursor-default text-xs text-muted-foreground">+{overflow}</span>
          </TooltipTrigger>
          <TooltipContent>
            <ul className="space-y-0.5">
              {overflowItems.map((item) => (
                <li key={item.id}>{item.name}</li>
              ))}
            </ul>
          </TooltipContent>
        </Tooltip>
      )}
    </div>
  );
}
